import { Container, Box, Typography } from "@mui/material";
import { onlineManager } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

function Error() {
  const { t } = useTranslation();
  return (
    <Container maxWidth="xl" sx={{ paddingY: 2 }}>
      <Box
        minHeight="70vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Typography variant="h6" textAlign="center">
          {onlineManager.isOnline() ? t("E.DEFAULT") : t("E.OFFLINE")}
        </Typography>
      </Box>
    </Container>
  );
}

export default Error;
